import { render, staticRenderFns } from "./salePersonManage.vue?vue&type=template&id=2ed73ac7&scoped=true&"
import script from "./salePersonManage.vue?vue&type=script&lang=js&"
export * from "./salePersonManage.vue?vue&type=script&lang=js&"
import style0 from "./salePersonManage.vue?vue&type=style&index=0&id=2ed73ac7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed73ac7",
  null
  
)

export default component.exports